
/**
 *  @class
 *  @function MapVideo
 */
if (!customElements.get('section-map-video')) {
    class MapVideo extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.iframe = this.querySelector('iframe');
        this.iframeVideoList=[];
        this.buttons = Array.from(this.querySelectorAll('.head_portrait_active_box'));
        this.nowPlayingIndex = 0;
        this.buttons.forEach((button, i) => {
           this.iframeVideoList.push(button.dataset.videourl);
            button.addEventListener('click', (el) => {
              this.buttonClick(button, i);
            });
        });
        this.windowWidth = window.innerWidth;
        this.querySelector('.prevBtn').addEventListener('click', (el) => {
          this.videoClick(0)
        });
        this.querySelector('.nextBtn').addEventListener('click', (el) => {
          this.videoClick(1)
        });
        this.buttons[0].addEventListener('lazyloaded', function (event) {
          this.srcset=this.dataset.imghover
        });
      }
      buttonClick(button, i){
        this.nowPlayingIndex = i;
        this.iframe.src = button.dataset.videourl;
        this.buttons.forEach((item, i) => {
          item.classList.remove('head_portrait_active_box_animation');
          item.srcset=button.dataset.srcset;
        });
        button.classList.add('head_portrait_active_box_animation');
        button.srcset=button.dataset.imghover
      }
      videoClick(type){
        type?this.nowPlayingIndex++:this.nowPlayingIndex--;
        let maxLength = this.windowWidth>768?8:this.iframeVideoList.length;
        this.nowPlayingIndex==maxLength?this.nowPlayingIndex=0:this.nowPlayingIndex<0?this.nowPlayingIndex=maxLength-1:'';
        this.buttonClick(this.buttons[this.nowPlayingIndex],this.nowPlayingIndex)
        //this.iframe.src=this.iframeVideoList[this.nowPlayingIndex]
      }
    }
    customElements.define('section-map-video', MapVideo);
}